import styled, { css } from 'styled-components'

export const TooltipWrapper = styled.div`
  ${({ theme }) => css`
    display: inline-block;

    .tooltip-area {
      ${theme.fonts.regular};
      max-width: 15rem;
      min-height: 2rem;
      border-radius: 0.25rem;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      opacity: 1;
    }
  `}
`

export const IconContainer = styled.div`
  ${({ theme }) => css`
    padding: ${theme.ToRem(1)};
    svg {
      height: ${theme.ToRem(16)};
      width: ${theme.ToRem(16)};
      path {
        fill: ${theme.colors.grey};
      }
    }
  `}
`
